"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var workspaceMemberStatusUtils_exports = {};
__export(workspaceMemberStatusUtils_exports, {
  WORKSPACE_MEMBER_STATUS_MESSAGE_MAX: () => WORKSPACE_MEMBER_STATUS_MESSAGE_MAX,
  extractLeadingStatusEmoji: () => extractLeadingStatusEmoji,
  getWorkspaceMemberStatusSubtitle: () => getWorkspaceMemberStatusSubtitle,
  isWorkspaceMemberStatusVisible: () => isWorkspaceMemberStatusVisible,
  trimWorkspaceMemberStatusMessage: () => trimWorkspaceMemberStatusMessage
});
module.exports = __toCommonJS(workspaceMemberStatusUtils_exports);
const WORKSPACE_MEMBER_STATUS_MESSAGE_MAX = 200;
function trimWorkspaceMemberStatusMessage(message) {
  const trimmed = message.trim();
  return Array.from(trimmed).slice(0, WORKSPACE_MEMBER_STATUS_MESSAGE_MAX).join("");
}
__name(trimWorkspaceMemberStatusMessage, "trimWorkspaceMemberStatusMessage");
function isWorkspaceMemberStatusVisible(s, now = Date.now()) {
  if (s === void 0) return false;
  if (s.clearAt !== void 0 && s.clearAt <= now) return false;
  const m = s.message?.trim() ?? "";
  return m !== "";
}
__name(isWorkspaceMemberStatusVisible, "isWorkspaceMemberStatusVisible");
function getWorkspaceMemberStatusSubtitle(s, now = Date.now()) {
  if (!isWorkspaceMemberStatusVisible(s, now)) return void 0;
  return s?.message?.trim() ?? "";
}
__name(getWorkspaceMemberStatusSubtitle, "getWorkspaceMemberStatusSubtitle");
const EMOJI_HEAD = /^\p{Extended_Pictographic}/u;
function extractLeadingStatusEmoji(raw) {
  const text = raw?.trim() ?? "";
  if (text === "") return void 0;
  try {
    const seg = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    const segments = [...seg.segment(text)].map((x) => x.segment);
    if (segments.length === 0) return void 0;
    if (!EMOJI_HEAD.test(segments[0])) return void 0;
    let out = segments[0];
    let i = 1;
    while (i < segments.length) {
      const s = segments[i];
      if (s === "\u200D" && i + 1 < segments.length && EMOJI_HEAD.test(segments[i + 1])) {
        out += s + segments[i + 1];
        i += 2;
        continue;
      }
      if (s === "\uFE0F" || /^[\u{1F3FB}-\u{1F3FF}]$/u.test(s)) {
        out += s;
        i++;
        continue;
      }
      break;
    }
    return out;
  } catch {
    const m = text.match(/^(\p{Extended_Pictographic})/u);
    return m?.[1];
  }
}
__name(extractLeadingStatusEmoji, "extractLeadingStatusEmoji");
//# sourceMappingURL=workspaceMemberStatusUtils.js.map
